import * as React from 'react';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import { ConnectState, ResourceCollectPageModelState } from '@/models/connect';
import { history } from 'umi';
import {
  OnMountAction,
  OnUnmountAction,
  OnChangeResourceTypeAction,
  OnChangeStatusAction,
  OnChangeKeywordsAction,
  OnBoomJuiceAction,
  OnClickLoadingMordAction,
  OnAwaited_KeywordsChange_Action,
} from '@/models/resourceCollectPage';
import FNoDataTip from '@/components/FNoDataTip';
import FLoadingTip from '@/components/FLoadingTip';
import { FI18n, FUtil } from '@freelog/tools-lib';
import * as AHooks from 'ahooks';
import styles from './index.less';
import FResourceTypeFilter from '@/components/FResourceTypeFilter';
import FComponentsLib from '@freelog/components-lib';
import { Space } from 'antd';
import FResourceCard from '@/components/FResourceCard';
import FListFooter from '@/components/FListFooter';
// import FDropdownMenu from '@/components/FDropdownMenu';
import FDropdown2 from '@/components/FDropdown2';
import FInput_Search from '@/components/FInput_Search';

interface ResourceCollectProps {
  dispatch: Dispatch;
  resourceCollectPage: ResourceCollectPageModelState;
}

const resourceStatusOptions = [
  { text: FI18n.i18nNext.t('filter_resource_status_all'), value: '#' },
  {
    // '上架'
    text: FI18n.i18nNext.t('filter_resource_status_availableforauth'),
    value: 1,
  },
  // '下架'
  { text: FI18n.i18nNext.t('filter_resource_status_pendingauth'), value: 4 },
  {
    // '待发行'
    text: FI18n.i18nNext.t('filter_resource_status_prepareforrelease'),
    value: 0,
  },
  {
    // '冻结'
    text: FI18n.i18nNext.t('filter_resource_status_removedbyfreelog'),
    value: 2,
  },
];

function ResourceCollect({ dispatch, resourceCollectPage }: ResourceCollectProps) {
  AHooks.useMount(() => {
    dispatch<OnMountAction>({
      type: 'resourceCollectPage/onMount',
    });
  });

  AHooks.useUnmount(() => {
    dispatch<OnUnmountAction>({
      type: 'resourceCollectPage/onUnmount',
    });
  });

  AHooks.useDebounceEffect(
    () => {
      dispatch<OnAwaited_KeywordsChange_Action>({
        type: 'resourceCollectPage/onAwaited_KeywordsChange',
      });
    },
    [resourceCollectPage.inputText],
    {
      wait: 300,
    },
  );

  if (resourceCollectPage.resource_ListState === 'loading') {
    return <FLoadingTip height={'calc(100vh - 140px)'} />;
  }

  if (resourceCollectPage.resource_ListState === 'noData') {
    return (
      <FNoDataTip
        height={'calc(100vh - 140px)'}
        // tipText={'未收藏任何资源'}
        tipText={FI18n.i18nNext.tJSXElement('my_library_empty')}
        // btnText={'前往资源市场'}
        btnText={FI18n.i18nNext.t('my_library_empty_btn')}
        onClick={() => history.push(FUtil.LinkTo.market())}
      />
    );
  }

  return (
    <>
      <div style={{ height: 40 }} />
      <div className={styles.filter}>
        <div className={styles.filterLeft}>
          <div>
            <span>{FI18n.i18nNext.t('resource_type')}：</span>

            <FResourceTypeFilter
              subjectType={'resource,collection'}
              value={resourceCollectPage.resourceTypeCodes}
              onChange={(value) => {
                dispatch<OnChangeResourceTypeAction>({
                  type: 'resourceCollectPage/onChangeResourceType',
                  payload: {
                    value: value,
                  },
                });
              }}
            />
          </div>
          <div style={{ marginLeft: 60, display: 'flex', alignItems: 'center' }}>
            <span>{FI18n.i18nNext.t('resource_state')}：</span>

            {/* <FDropdownMenu
              options={resourceStatusOptions as any}
              onChange={(value) => {
                dispatch<OnChangeStatusAction>({
                  type: 'resourceCollectPage/onChangeStatus',
                  payload: {
                    value: value === '#' ? value : (Number(value) as 0),
                  },
                });
              }}
              text={
                resourceStatusOptions.find((rs) => {
                  return rs.value === resourceCollectPage.resourceStatus;
                })?.text || ''
              }
            /> */}

            <FDropdown2
              autoArrow={true}
              // getPopupContainer={() => ref_Root.current as HTMLElement}
              menu={{
                // selectedKeys: [nodeManagerPage.exhibit_SelectedStatus],
                items: resourceStatusOptions.map((rs) => {
                  return {
                    key: rs.value,
                    label: rs.text,
                  };
                }),
                onClick: (value) => {
                  dispatch<OnChangeStatusAction>({
                    type: 'resourceCollectPage/onChangeStatus',
                    payload: {
                      value: value.key === '#' ? value.key : (Number(value.key) as 0),
                    },
                  });
                },
              }}
            >
              <span>
                {resourceStatusOptions.find((rs) => {
                  return rs.value === resourceCollectPage.resourceStatus;
                })?.text || ''}
              </span>
            </FDropdown2>
          </div>
        </div>
        <Space size={20}>
          {/* <FComponentsLib.FInput.FSearch */}
          <FInput_Search
            value={resourceCollectPage.inputText}
            style={{ width: 400 }}
            // placeholder={FI18n.i18nNext.t('myresourses_search_hint')}
            placeholder={FI18n.i18nNext.t('resourcemngt_search_hint')}
            onChange={(e) => {
              dispatch<OnChangeKeywordsAction>({
                type: 'resourceCollectPage/onChangeKeywords',
                payload: {
                  value: e.target.value,
                },
              });
            }}
          />
        </Space>
      </div>

      {resourceCollectPage.resource_ListState === 'noSearchResult' && (
        <FNoDataTip
          height={'calc(100vh - 220px)'}
          // tipText={'没有符合条件的资源'}
          tipText={FI18n.i18nNext.t('msg_search_no_resault_found', {
            SearchKeyWords: resourceCollectPage.inputText_search,
          })}
          btnText={'前往资源市场'}
          onClick={() => history.push(FUtil.LinkTo.market())}
        />
      )}

      {resourceCollectPage.resource_ListState === 'loaded' && (
        <>
          <div style={{ height: 40 }} />
          <div className={styles.Content}>
            {resourceCollectPage.resource_List.map((i, j) => {
              return (
                <FResourceCard
                  key={i.id}
                  resource={i}
                  type={'favorite'}
                  className={styles.FResourceCard}
                  onBoomJuice={() => {
                    dispatch<OnBoomJuiceAction>({
                      type: 'resourceCollectPage/onBoomJuice',
                      payload: i.id,
                    });
                  }}
                  onClickDetails={() => {
                    if (i.collection) {
                      window.open(
                        FUtil.LinkTo.collectionDetails({
                          collectionID: i.id,
                        }),
                      );
                    } else {
                      window.open(
                        FUtil.LinkTo.resourceDetails({
                          resourceID: i.id,
                        }),
                      );
                    }
                  }}
                  // collection={{
                  //   status: j % 2 === 0 ? 'finish' : 'unFinish',
                  //   count: j,
                  // }}
                  // onClickEditing={() => onClickEditing && onClickEditing(i.id, i, j)}
                  // onClickRevision={() => onClickRevision && onClickRevision(i.id, i, j)}
                  // onClickMore={() => onClickMore && onClickMore(i.id, i, j)}
                />
              );
            })}
            <div className={styles.bottomPadding} />
            <div className={styles.bottomPadding} />
            <div className={styles.bottomPadding} />
            <div className={styles.bottomPadding} />
          </div>
          <div style={{ height: 100 }} />
          <FListFooter
            state={resourceCollectPage.resource_ListMore}
            onClickLoadMore={async () => {
              // await fetchResourceList(false);
              dispatch<OnClickLoadingMordAction>({
                type: 'resourceCollectPage/onClickLoadingMord',
              });
            }}
          />
        </>
      )}
      <div style={{ height: 100 }} />
    </>
  );
}

export default connect(({ resourceCollectPage }: ConnectState) => ({
  resourceCollectPage: resourceCollectPage,
}))(ResourceCollect);
